import { Button, FormControlLabel, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import soixante from '../../../img/cleanCircle.png';
import Switch from '@mui/material/Switch';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from '@mui/material/Autocomplete';
import React from "react";
const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
      '&:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      '&:after': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
  }));


export default function PliesConfig({remarks, setRemarks,setEntete, entete, numberplies, setNumberplies, angles, setAngles, open, dialogValue, setDialogValue, toggleOpen, handleClose, remarksAuto, setRemarksAuto, calculatedangles, setCalculatedangles, description, setDescription, activeCircle, setActiveCircle, activeDesc, setActiveDesc}) {
    const [value, setValue] = React.useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        setValue({
          title: dialogValue.title
        });
        setRemarksAuto(remarksAuto => [...remarksAuto, dialogValue.title])
    
        handleClose();
      };
    return  (
        <>  <center>Include in the final report ?   <FormControlLabel
          control={<Android12Switch defaultChecked checked={!activeCircle} onChange={(e) => { setActiveCircle(!activeCircle) }}/>}
          label="Plies"
        />
          <FormControlLabel
            control={<Android12Switch defaultChecked checked={!activeDesc} onChange={(e) => { setActiveDesc(!activeDesc) }}/>}
            label="Description of the process"
          /></center>
          <div className="stopwatch" style={{ textAlign: 'center' }}>

            <br />
            <span style={{ width: "auto", textAlign: 'center' }}>
              <br />
              {activeCircle ? <>No data will be visualised for the plies</> : null}
              <div hidden={activeCircle}>
                <div style={{ fontSize: '11px' }}>Degrees are automatically calculated to fit in the range [-180°,180°]</div  ><br />
                <TextField
                  id="plies"
                  style={{ margin: 10 }}
                  inputProps={{ style: { textAlign: 'center', width: 50 } }}
                  label="Plies"
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  type="number"
                  value={numberplies}
                  onChange={(e) => {
                    if (e.target.value > 0 && e.target.value < 17) {
                      e.target.value = e.target.value
                      setNumberplies(e.target.value)
                      Array.apply(null, { length: numberplies }).map((e, i) => { (angles.push(0)); calculatedangles.push([(Math.cos((0 - 90) * Math.PI / 180) * 20), (Math.sin((0 - 90) * Math.PI / 180) * 20)]) })

                    }
                    else {
                      if (e.target.value > 15) { e.target.value = 16; setNumberplies(16); }
                      else { e.target.value = 0; setNumberplies(0) }
                    }
                  }}
                /><br />
                {Array.apply(null, { length: numberplies }).map((e, i) => (
                  <span className="busterCards" style={{ margin: '5px' }} key={i}>
                    <br /><div style={{ fontSize: 10 }}> 0°</div>
                    <img src={soixante} style={{ transform: `rotate(${angles[i]}deg)`, margin: 2, width: '125px' }} />
                    <div style={{ fontSize: 10 }}> 180°</div>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                      <TextField
                        label="Ply number"
                        id="outlined-start-adornment"
                        type='number'
                        value={i + 1}
                        style={{ width: '100px' }}
                        sx={{ m: 1, width: '25ch' }}
                        inputProps={{ style: { textAlign: 'center' } }}


                      />

                      <TextField
                        label="Degree"
                        id="outlined-start-adornment"
                        type='number'
                        value={angles[i]}
                        style={{ width: '100px' }}
                        sx={{ m: 1, width: '25ch' }}
                        onChange={(e) => {
                          ['+', '-'].includes(e.key) && e.preventDefault();
                          e.target.value = e.target.value % 360;
                          if (e.target.value > 180) e.target.value = e.target.value - 360;
                          if (e.target.value < -180) e.target.value = Math.abs(e.target.value) * (-1) + 360;

                          angles[i] = e.target.value;
                          setAngles(angles => [...angles]);
                          calculatedangles[i] = new Array(2);
                          calculatedangles[i][0] = ((Math.cos((e.target.value - 90) * Math.PI / 180) * 20)); // (- 90) car on a 380 comme max angle, (20) le diametre du cercle
                          calculatedangles[i][1] = ((Math.sin((e.target.value - 90) * Math.PI / 180) * 20));
                           setCalculatedangles(calculatedangles => [...calculatedangles]);

                        }}


                        inputProps={{ style: { textAlign: 'center' } }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">°</InputAdornment>,
                        }}
                      /></div>

                    <div style={{ margin: '10px' }}>
                      <Autocomplete

                        id="combo-box-demo"
                        options={remarksAuto}
                        sx={{ width: 300 }}
                        value={remarks[i]}
                        onChange={(event, value) => {//remarks[i]=value
                          if ((remarksAuto.indexOf(value) > -1 === false) && value) {
                            setTimeout(() => {
                              toggleOpen(true);
                              setDialogValue({
                                title: value
                              });
                            });
                            //remarksAuto.push(value)
                          }
                          remarks[i] = value;
                          setRemarks(remarks => [...remarks]);
                        }}
                        renderInput={(params) => <TextField {...params} label="Ply Description" />}
                        freeSolo
                      />
                      <Dialog open={open} onClose={handleClose}>
                        <form onSubmit={handleSubmit}>
                          <DialogTitle>Add a new remark</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              Do you want to add this new description ?
                            </DialogContentText>
                            <TextField
                              autoFocus
                              margin="dense"
                              id="name"
                              value={dialogValue.title}
                              onChange={(event) =>
                                setDialogValue({
                                  ...dialogValue,
                                  title: event.target.value,
                                })
                              }
                              label="Ply Description"
                              type="text"
                              variant="standard"
                            />

                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button type="submit">Add</Button>
                          </DialogActions>
                        </form>
                      </Dialog>
                    </div>
                  </span>
                ))}
              </div>

              <br /><br /><br />
              Drying and Water Break Test performed
              <div onChange={(e) => { entete[28] = e.target.value; setEntete(entete => [...entete]); }}  >
                <input type="radio" value="Yes." name="waterBreak" checked={entete[28] === 'Yes.'} /> Yes
                <input type="radio" value="No." name="waterBreak" checked={entete[28] === 'No.'} /> No
                <input type="radio" value="Other" name="waterBreak" checked={entete[28] !== 'Yes.' && entete[28] !== 'No.'} /> Other
                {entete[28] !== 'Yes.' && entete[28] !== 'No.' ? <TextField
                  label="Other"
                  value={entete[28]}
                  style={{ width: '250' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => { entete[28] = e.target.value; setEntete(entete => [...entete]); }}

                /> : null}
              </div> <br />

              {activeDesc ? <>There will be no description for this part ! </> : <TextField
                inputProps={{
                  maxLength: 386,
                }}
                id="outlined-multiline-flexible"
                label="Description of the process (optional)"
                multiline
                maxRows={5}
                style={{ width: '60%' }}
                value={description}
                onChange={(e) => { setDescription(e.target.value.replace(/(\r\n|\n|\r)/gm, "")) }}

              />}


              <br /><br /><br />
            </span>
          </div>
        </>
      )
}